import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarIcon } from '../icons/InterfaceIcons';

interface AssignedTest {
    test_id: string | number;
    name: string;
    assigned_at: string;
    duration: number;
}

export const UpcomingTestCard = ({ assignedTests }) => {
    const navigate = useNavigate();
    const upcomingTest = assignedTests && Object.keys(assignedTests).length > 0
        ? Object.values(assignedTests)[0] as AssignedTest
        : null;

    return (
        <div className="bg-brand-surface border border-brand-border rounded-xl p-6 flex flex-col h-full shadow-card">
            <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-xl text-brand-text-primary">Upcoming Test</h3>
                <CalendarIcon className="w-6 h-6 text-brand-text-secondary" />
            </div>
            {upcomingTest ? (
                <>
                    <div className="flex-grow">
                        <p className="font-semibold text-brand-text-primary">{upcomingTest.name}</p>
                        <div className="mt-2 flex items-center space-x-2 text-brand-text-secondary">
                             <span className="text-sm font-medium bg-brand-primary/10 text-brand-primary px-2 py-1 rounded">
                                {new Date(upcomingTest.assigned_at).toLocaleDateString()}
                            </span>
                            <span className="text-sm">{upcomingTest.duration} mins</span>
                        </div>
                    </div>
                    <button 
                        onClick={() => navigate(`/test/${upcomingTest.test_id}/instructions`)}
                        className="mt-4 w-full bg-indigo-gradient text-white font-bold py-2.5 px-4 rounded-lg transition-all duration-300">
                        Start Test
                    </button>
                </>
            ) : (
                <div className="flex-grow flex items-center justify-center">
                    <p className="text-center text-sm text-brand-text-secondary">No upcoming tests assigned. Great job staying on top of your work!</p>
                </div>
            )}
        </div>
    );
};
